import request from '@/axios'

// export function fetch_minor () {
//   return request({
//     url:'ClientUser/details',
//     method: 'GET'
//   })
// }

export function fetch_minor (customer_id) {
  return request({
    url:`/ClientUser/get_child_list/${customer_id}`,
    method: 'GET'
  })
}

export function FetchPlatformModuleAccess () {
  return request({
    url:'/ClientUser/platform_module_access',
    method: 'GET'
  })
}

export function ModluePermission (payload) {
  return request({
    url:'/ClientUser/set_module_access',
    method: 'POST',
    data: payload
  })
}


export function FetchPlatformModuleAccessChild (id) {
  console.log(id)
  return request({
    url:`/ClientUser/platform_module_access/${id}`,
    method: 'GET'
  })
}